/** Date filters use whole UTC calendar days, matching the API's daily buckets. */
export const inputDay = (date: Date | null) =>
  date ? date.toISOString().slice(0, 10) : "";
export const reportBoundary = (date: Date | null, end = false) =>
  date
    ? `${inputDay(date)}T${end ? "23:59:59.999" : "00:00:00.000"}Z`
    : undefined;
export const reportPreset = (days: number, now = new Date()) => {
  const end = new Date(`${inputDay(now)}T00:00:00.000Z`);
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - days + 1);
  return { start, end };
};
